import AppProvider from 'providers/app';
import AppRoutes from 'routes';
import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import LazyBagelChatHost from 'features/bagel/chat/LazyBagelChatHost';

function App() {
  // render routes
  return (
    <HelmetProvider>
      <AppProvider>
        <AppRoutes />
        {/* Global Bagel AI chat — lazy-loaded; persists across navigation once mounted */}
        <LazyBagelChatHost />
      </AppProvider>
    </HelmetProvider>
  );
}

export default App;
